// #region imports

// --- Angular
import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';

// --- RxJs
import { Observable, Subscription } from 'rxjs';

// --- 3rd party
import { TranslateService } from '@ngx-translate/core';

// --- HS Code
import {
  RegistrationResult,
  EmailAddressValidationModel,
  LanguageModel
} from '../../../models/';
import { AppService } from '../../../core/services/app.service';
import { OidcService, LanguagesBaseService, RegistrationBaseService } from '../../../core/services';
import { RegistrationBase } from '../registration-base';
import { ReCaptchaV3Service } from 'ngx-captcha';

// #endregion

@Component({
  selector: 'hs-book',
  templateUrl: './book.component.html',
  styleUrls: ['./book.component.scss']
})
export class BookComponent extends RegistrationBase implements OnInit, OnDestroy {
  isSelectionMade: boolean;

  constructor(
    protected router: Router,
    protected registrationService: RegistrationBaseService,
    protected appService: AppService,
    protected oidcService: OidcService,
    protected languageService: LanguagesBaseService,
    protected translate: TranslateService,
    protected reCaptchaV3Service: ReCaptchaV3Service
  ) {
    super(router, registrationService, appService, oidcService, languageService, translate, reCaptchaV3Service);

    this.isSelectionMade = false;
  }

  ngOnInit() {
    this._onInit();
  }

  ngOnDestroy() {
    this._onDestroy();
  }

  onLoginSelection(e: any): void {
    if (!this.isSelectionMade) {
      this.onLogin();
    }
  }

  onRegisterSelection(e: any): void {
    if (!this.isSelectionMade) {
      this.isSelectionMade = true;
    }
  }
}
